<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>{{message}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close *ngIf="askForConfirmation" i18n>Cancel</button>
  <button mat-button [mat-dialog-close]="true" color="warn" *ngIf="askForConfirmation"i18n>Confirm</button>
  <button mat-button class="okButton" [mat-dialog-close]="true" color="primary" *ngIf="!askForConfirmation"i18n>Ok</button>
</mat-dialog-actions>
